import React from 'react';

import styles from './DeliveryShippingAddress.module.css'

import {Input} from "../../../../../../../../ui/DataEntry/Input/Input.tsx";
import {cn} from "../../../../../../../../utils/cn.ts";
import {Order} from "../../../../../../../../types/Order.interface.ts";

interface Props {
    offer: Order,
}

export const DeliveryShippingAddress: React.FC<Props> = ({offer}) => {

    const postcode = offer.delivery.postcode || '';
    const city = offer.delivery.townName || '';
    const street = offer.delivery.street || '';
    const streetNumber = offer.delivery.house || '';
    const apartmentNumber = offer.delivery.apartment || '';

    return (
        <div>
            <div>
                <h4 className={styles.title}>Адрес доставки</h4>
                <div className={styles.inputs}>
                    <Input
                        className={cn(styles.input, styles.postcode)}
                        label='Индекс'
                        value={postcode}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.city)}
                        label='Город'
                        value={city}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.street)}
                        label='Улица'
                        value={street}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.streetNumber)}
                        label='Дом'
                        value={streetNumber}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.apartmentNumber)}
                        value={apartmentNumber}
                        label='Кв./Офис'
                        disabled={true}
                    />

                </div>
            </div>
        </div>
    );
};